<p-menubar>
  <ng-template pTemplate="start">
    <button
      pButton
      pRipple
      (click)="collapseSidebar()"
      type="button"
      label=""
      icon="pi pi-bars"
      class="p-button-text p-button-sm p-button-plain collapse-btn ms-md-3"
    ></button>
  </ng-template>
  <ng-template pTemplate="end">
    <div class="d-flex align-items-center pe-4" style="margin-top: 6px;">
      <a routerLink="/cancellations" class="cancellation-nav-btn me-2" *ngIf="showCancellationsNav">
        <i class="bi bi-exclamation-triangle"></i>
        <span class="nav-btn-label">Cancellations</span>
        <span class="cancellation-badge" *ngIf="cancellationCount > 0">{{ cancellationCount }}</span>
      </a>

      <!-- Notification Icon -->
      <a routerLink="/notifications" class="notification-icon me-3" *ngIf="loading">
        <i class="bi bi-bell fs-5"></i>
        <span class="notification-badge" *ngIf="notificationCount > 0">{{ notificationCount }}</span>
      </a>

      <div class="dropdown" style="z-index: 1000 !important;" *ngIf="loading">
        <div class="d-flex" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
          <div class="avatar">
            <app-user-avatar
              [src]="currentUser?.logo"
              [name]="currentUser?.name"
              [fname]="currentUser?.fname"
              [lname]="currentUser?.lname"
              [size]="40"
            ></app-user-avatar>
          </div>
          <div class="name-box">
            <p class="m-0">{{ currentUser?.name }}</p>
            <span>{{ currentUser?.email }}</span>
          </div>
        </div>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li><a class="dropdown-item" routerLink="/profile">
            <i class="bi bi-person"></i> View Profile
          </a></li>
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item logout-link" (click)="logout()">
            <i class="bi bi-box-arrow-right text-danger"></i> Logout
          </a></li>
        </ul>
      </div>
    </div>
  </ng-template>
</p-menubar>
